import { add, qs } from '@fluorescent/dom';

const selectors = {
  sprForm: '.spr-form',
  shopifySection: '.shopify-section',
};

export default function () {
  const sprForm = qs(selectors.sprForm, document);
  const wrappingContainer = sprForm.closest(selectors.shopifySection);

  // Add wrapping section classes
  if (wrappingContainer.parentNode.classList.contains('main')) {
    add(wrappingContainer, 'section');
  }
}
